import { Badge } from '../../../../../../components/atoms/badge/badge';
import {
  useAllRespondentTypes,
  useAnswersForRespondentType,
  useRenderContext,
} from '../../../../context/render-context';
import { Survey } from '../../../../survey-types';
import * as surveyUtils from '../../../../utils/surveys/surveys';
import { WithIndicator } from '../../indicators/with-indicator';
import { AnswersBreakdownProps } from '../types';

const AnswersForRespondentType = ({
  questionName,
  respondentType,
  survey,
}: {
  readonly questionName: string;
  readonly respondentType: string;
  readonly survey: Survey;
}) => {
  const answers = useAnswersForRespondentType(respondentType);
  const answer = answers?.[questionName];
  if (!survey || !answer) return null;

  return (
    <WithIndicator displayIndicator respondentType={respondentType}>
      <Badge appearance="secondary" className="first:mr-0 mr-2.5 last:mr-0" size="lg">
        {answer}
      </Badge>
    </WithIndicator>
  );
};
const Answers = ({
  questionName,
  index,
  allRespondents,
  survey,
}: {
  readonly questionName: string;
  readonly index: number;
  readonly allRespondents: boolean;
  readonly survey: Survey;
}) => {
  const allRespondentTypes = useAllRespondentTypes();
  const { selectedRespondentType } = useRenderContext();
  if (!selectedRespondentType) return <div>No respondent type selected</div>;

  const questionTitle = surveyUtils.getQuestionByName(survey, questionName)?.title;

  const respondentTypes = allRespondents ? allRespondentTypes : [selectedRespondentType];
  return (
    <>
      <div className="text-typography">
        {index + 1}. {questionTitle}
      </div>
      {respondentTypes.map((rt) => (
        <AnswersForRespondentType
          key={`${questionName}-${rt}`}
          questionName={questionName}
          respondentType={rt}
          survey={survey}
        />
      ))}
    </>
  );
};

export const AnswersBreakdown = ({ answerBreakdown, allRespondents, survey }: AnswersBreakdownProps) => (
  <ol className="flex flex-col gap-2">
    {answerBreakdown?.map(
      ({ questionName }, index) =>
        questionName && (
          <Answers
            allRespondents={allRespondents}
            index={index}
            key={questionName}
            questionName={questionName}
            survey={survey}
          />
        )
    )}
  </ol>
);
